const BREAK_COLOR = '#94A3B8'

interface Props {
  startTimeIso: string
}

function formatTime(iso: string): string {
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export const WeekBreakPill = ({ startTimeIso }: Props) => (
  <div
    className="flex items-center rounded px-1 py-0.5 text-[11px] leading-tight text-white truncate"
    style={{ backgroundColor: BREAK_COLOR }}
  >
    <span className="truncate">Pause {formatTime(startTimeIso)}</span>
  </div>
)
